module.exports = __webpack_public_path__ + "static/phlSTEMecosystem-c3e0358e2dbbe7a783e420ada10baf35.png";